import {requirePermission} from '@/modules/auth/permissions'
import {SettingsForm} from '@/modules/settings/components/settings-form/settings-form'
import {NewResourceFormContainer} from '@cypro/ui/components/ui/new-resource-form-container'
import {NewResourceFormHeader} from '@cypro/ui/components/ui/new-resource-form-header'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'

export const Route = createFileRoute('/configuration/settings/')({
  beforeLoad: requirePermission('settings.manage'),
  component: SettingsPage,
})

function SettingsPage() {
  const {t} = useTranslate('common')

  return (
    <NewResourceFormContainer>
      <NewResourceFormHeader title={t('settings')} description={t('you_can_update_global_settings')} />
      <SettingsForm />
    </NewResourceFormContainer>
  )
}
